import { Dialog } from '@headlessui/react'
import { IKImage } from 'imagekitio-react'
import React from 'react'
import { useSelector } from 'react-redux'

const ExitPopUp = ({isModalEnabled , setIsModalEnabled, quizRef}) => {
    
    const betaProductUser = useSelector(store => store?.personaliseCourse?.betaUsers)
    const user_name = useSelector((store) => store?.profileDetails?.name);
    const first_name = useSelector(store=>store?.profileDetails?.first_name);
    console.log("this is my name", user_name);
  return (
    <Dialog
    open={isModalEnabled}
    onClose={() => null}
    as="div"
    style={{ zIndex: "9999999999" }}
    className="fixed inset-0 z-[9999999999] -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-40 md:justify-start"
  >
    <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
    <Dialog.Title />
    <Dialog.Description />
    <div className="relative z-[9999999999] flex  w-11/12 flex-col py-4 px-2 justify-center items-center text-center overflow-auto rounded-xl bg-white  shadow-2xl  md:w-1/4 md:p-4 lg:w-1/4">

        <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={"https://assets.learntube.ai/files/Content_player/Group_7111.svg?updatedAt=1680072394715"}
            transformation={[{
                "height": "110",
                "width": "110",
            }]}
            className=""
        />
        <div className='text-lg font-bold mt-2'>Don't miss out {user_name?.split(" ")?.[0]}</div>
        {(!betaProductUser?.ninjacurate_is_paid && !betaProductUser?.certified_is_paid) ? <p className='text-sm mt-2'>Complete quiz to unlock full access.</p> : <div className='text-sm mt-2'>Complete the quiz <span className='font-bold'>now</span> to unlock free 7 day trial of our best <span className='font-bold'>LearnTube Max plan.</span></div>}
        <div className='text-sm mt-2'>Most people can complete this quiz in <span className='font-bold'>just 5 minutes</span>, so can you!</div>
        <button className='w-full bg-[#13B284] text-white rounded-lg py-2 mt-2' onClick={(e)=> {
          if(quizRef?.current){
          quizRef?.current?.scrollIntoView({behavior:'smooth'})
          }
          setIsModalEnabled(false)}}>Take the quiz</button>
    </div>
  </Dialog>
  )
}

export default ExitPopUp
